import React from 'react';
import './progress-update-modal.css';
import { ProgressUpdate } from '../../progress-update';
import { Heading } from '../../heading';
import { Paragraph } from '../../paragraph';
import PropTypes from 'prop-types';
import { returnUpdatedScores } from '../../../helpers/active-game';

const ProgressUpdateModal = props => {
    const { previousScores, gameScores, feedback } = props;

    const updatedScores = returnUpdatedScores(previousScores, gameScores);

    return (
        <div className="progress-update-modal">
            <div className="progress-update-modal__header">
                <Heading
                    headingType="h3"
                    colorScheme="dark"
                    align="center"
                    verticalAlign="middle"
                    withSpacing={false}
                >
                    Progress Update
                </Heading>
            </div>
            <div className="progress-update-modal__progress-update">
                <ProgressUpdate
                    titlePosition="top"
                    previousScores={previousScores}
                    updatedScores={updatedScores}
                />
            </div>
            <div className="progress-update-modal__feedback">
                <Paragraph colorScheme="dark" withSpacing={false}>
                    {feedback}
                </Paragraph>
            </div>
        </div>
    );
};

ProgressUpdateModal.defaultProps = {
    titlePosition: 'bottom',
};

ProgressUpdateModal.propTypes = {
    titlePosition: PropTypes.oneOf(['bottom', 'top']),
    feedback: PropTypes.string.isRequired,
    previousScores: PropTypes.objectOf(PropTypes.number).isRequired,
    gameScores: PropTypes.objectOf(PropTypes.number).isRequired,
};

export { ProgressUpdateModal };
